import styled from "styled-components";
import { T } from "src/apps/components/i18n/Translation";

import { AvailableActor } from "src/contexts/documentationArea/domain/AvailableActor";
import { ActorId } from "src/contexts/documentationArea/domain/ActorId";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { colors } from "@permisso/permisso-components";

export const ACTOR_SELECTOR_READ_ONLY = "documentation_area.actor_selector.read_only";
const ACTOR_SELECTOR_YOU = "documentation_area.actor_selector.you";

interface ActorItemProps {
  actor: AvailableActor;
  isSelected: boolean;
  isOwner: boolean;
  onSelect: (actorId: ActorId) => void;
}

export const ActorItem = ({ actor, isSelected, isOwner, onSelect }: ActorItemProps) => {
  const { t } = useTranslations();
  return (
    <ActorRow
      $selected={isSelected}
      role="option"
      aria-selected={isSelected}
      onClick={() => onSelect(actor.id)}
    >
      <ActorNameText $selected={isSelected} className="text mp-mask">
        {actor.fullName} {isOwner ? <T k={t(ACTOR_SELECTOR_YOU)} /> : null}
      </ActorNameText>
      {actor.readOnly ? (
        <ReadOnlyPill>
          <T k={t(ACTOR_SELECTOR_READ_ONLY)} />
        </ReadOnlyPill>
      ) : null}
    </ActorRow>
  );
};

const ActorRow = styled.button.attrs({ type: "button" })<{ $selected?: boolean }>`
  all: unset;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background-color: ${({ $selected }) => ($selected ? colors.grey300 : "transparent")};
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${colors.grey300};
  }
`;

const ActorNameText = styled.div<{ $selected?: boolean }>`
  min-width: 0;
  overflow: hidden;
  font-weight: ${({ $selected }) => ($selected ? 700 : 400)};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ReadOnlyPill = styled.span`
  color: ${colors.grey800};
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.2;
  background-color: ${colors.grey300};
  border-radius: 999px;
  padding: 0.25rem 0.625rem;
  white-space: nowrap;
`;
